"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsUrl = exports.isUrl = void 0;
const classValidator = __importStar(require("class-validator"));
const mol_validator_utils_1 = require("../utils/mol-validator-utils");
const IsString_1 = require("./IsString");
async function isUrl(value, args, constraints) {
    var _a, _b, _c;
    const isStringResults = await (0, IsString_1.isString)(value, args, constraints);
    if (isStringResults.pass === false || isStringResults.skipped) {
        return isStringResults;
    }
    // Defaults optimized for web URL validations
    constraints = constraints !== null && constraints !== void 0 ? constraints : {};
    constraints.isUrlOptions = (_a = constraints.isUrlOptions) !== null && _a !== void 0 ? _a : {};
    constraints.isUrlOptions.require_protocol = (_b = constraints.isUrlOptions.require_protocol) !== null && _b !== void 0 ? _b : true; // Not limited to http/https
    constraints.isUrlOptions.require_tld = (_c = constraints.isUrlOptions.require_tld) !== null && _c !== void 0 ? _c : false; // False allows `localhost` to pass
    /**
     * FIXME: Waiting for class-validator to use validatorjs v13.1.17
     * By default, URLs can only have up to 2083 characters (IE limitation)
     * We have to skip URL check for now to make it work
     * https://github.com/validatorjs/validator.js/pull/1397
     */
    // constraints.isUrlOptions.validate_length = constraints.isUrlOptions.validate_length ?? 4000;	// Allows for URL length beyond 2083
    if (value.length > 2083 && value.length <= 4000) {
        return { pass: true };
    }
    if (!classValidator.isURL(value, constraints === null || constraints === void 0 ? void 0 : constraints.isUrlOptions)) {
        if (constraints.isUrlOptions.require_protocol) {
            return { pass: false, message: "should be a valid URL with a protocol" };
        }
        return { pass: false, message: "should be a valid URL" };
    }
    return { pass: true };
}
exports.isUrl = isUrl;
/**
 * Validates that the value is a valid URL
 * NOTE: Differs from the class-validator version by allowing additional constraints
 */
function IsUrl(constraints, options) {
    return (0, mol_validator_utils_1.registerValidatorDecorator)({
        name: "IsUrl",
        defaultMessage: "should be a valid URL",
        options,
        constraints,
        validateFn: isUrl,
    });
}
exports.IsUrl = IsUrl;
//# sourceMappingURL=IsUrl.js.map